export default __webpack_public_path__ + "static/media/DSC04319_edited.65cc377e.jpg";